export default {
  isSidebarOpen: false,
  isLoading: false,
  isClassListVisible: false,
};
